import { LitElement, html } from 'lit';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./MediaCarousel.scss';

class MediaCarousel extends LitElement {
  static styles = [styles];

  static get properties() {
    return {
      media: { type: Array },
      service: { type: String },
      currentSlide: { type: Number },
    };
  }

  constructor() {
    super();

    this.currentSlide = 0;
  }

  updateDimensions() {
    const { media } = this;
    const wrapperEl = this.shadowRoot.querySelector('#media-carousel');
    const sliderEl = wrapperEl.firstElementChild;
    const width = wrapperEl.clientWidth;
    this.wrapperWidth = width;
    this.sliderWidth = media.length * width;
    sliderEl.style.width = `${this.sliderWidth}px`;

    if (sliderEl.hasChildNodes()) {
      const slides = sliderEl.children;
      for (let i = 0; i < slides.length; i += 1) {
        const element = slides[i];
        element.style.width = `${this.wrapperWidth}px`;
      }
    }
  }

  updated() {
    super.updated();
    this.updateDimensions();
  }

  handleNextClick() {
    const { media } = this;
    const { currentSlide } = this;

    if (currentSlide < media.length - 1) {
      this.currentSlide = currentSlide + 1;
    }
  }

  handlePreviousClick() {
    const { currentSlide } = this;

    if (currentSlide > 0) {
      this.currentSlide = currentSlide - 1;
    }
  }

  render() {
    const { media, service, wrapperWidth, currentSlide } = this;
    const x = -(wrapperWidth * currentSlide);

    return html`
      <div class="media-carousel__container">
        <div
          class="media-carousel__bg"
          style=${`background-image: url(${media[0].thumbnail})`}
        ></div>
        <div class="media-carousel" id="media-carousel">
          <div class="media-carousel__slider" style=${`transform: translateX(${x}px)`}>
            ${media.map((slide, i) => {
              return html`
                <media-viewer
                  class="media-carousel__slide"
                  .media=${slide}
                  service=${service}
                  ?controls=${true}
                  ?playing=${currentSlide === i}
                ></media-viewer>
              `;
            })}
          </div>
          <button
            class=${classNames('media-carousel__btn media-carousel__previous', {
              'media-carousel__btn--disabled': currentSlide === 0,
            })}
            @click=${this.handlePreviousClick}
          ></button>
          <button
            class=${classNames('media-carousel__btn media-carousel__next', {
              'media-carousel__btn--disabled': currentSlide >= media.length - 1,
            })}
            @click=${this.handleNextClick}
          ></button>
        </div>
      </div>
    `;
  }
}

export default MediaCarousel;
